import ImageCarbon from "../../../assets/images/technologies/ImageCarbon.svg";
import ImageGas from "../../../assets/images/technologies/ImageGas.svg";
import ImageMesh from "../../../assets/images/technologies/ImageMesh.svg";
import ImageMist from "../../../assets/images/technologies/ImageMist.svg";
import ImageSAP from "../../../assets/images/technologies/ImageSAP.svg";

export const TechnologyItems = {
  ActivatedCarbon: {
    src: ImageCarbon,
  },
  MistEliminators: {
    src: ImageMist,
  },
  GasScrubbers: {
    src: ImageGas,
  },
  MeshPad: {
    src: ImageMesh,
  },
  SAP: {
    src: ImageSAP,
  },
};
